import axiosServices from 'utils/axios';
import { GenericTableConfigDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';

export const getConfig = async (configId: number): Promise<GenericTableConfigDto> => {
    const res = await axiosServices.get<GenericTableConfigDto>(
        `${InsideFifaBackOfficeEndpoints.GenericTables.Configs}/${configId}`,
    );

    return res.data;
};
